<template>
  <div class="agreeWrap">
    <div class="container-bd">
      <div class="c-left">
        <h1 align="center">MeetNovels User Agreement Privacy Policy</h1>
        <h3>Last Updated: Aug 24, 2022</h3>
        <div class="mod mod-base news">
          <div class="bd">
            <p>
              Preface:
            </p>
            <p>
              Welcome to use MeetNovels and services!
            </p>
            <p>
              In order to use the MeetNovels services (hereinafter referred to as "<b>The Software</b>" or "<b>The Service</b>"), you should read and abide by the "User's Personal Information Protection and Privacy Policy Agreement" (hereinafter referred to as the "<b>Agreement</b>").
            </p>
            <p>
              Please read carefully and fully understand the content of each clause, especially the corresponding clauses that exempt or limit liability, and the separate agreement for opening or using a certain service, and choose to accept or not. Restrictions and exemptions have been reminded of you in bold. We will provide you with corresponding services after we have clearly obtained your consent and acceptance.
            </p>
            <p>
              The terms under this agreement can be changed by this software at any time, and you should check it regularly. Once the terms of the agreement are changed, the software will be updated on this page, and the changes will be provided on the relevant pages, and you will be notified separately. The revised agreement has been announced and effectively replaces the original agreement. You have the right not to accept the revised agreement, but it may cause you to stop using certain software or services provided by this software. You can check the latest user personal information protection and privacy policy at any time on this page.
            </p>
            <p>
              If you violate this agreement, the software has the right to unilaterally restrict, suspend or terminate the provision of this service at any time in accordance with the violation, and has the right to hold you accountable.
            </p>
            <p>
              If you are under the age of 18, please read this agreement and other aforementioned agreements with your guardian, and obtain the consent of your parent or legal guardian in advance. If you are the guardian of a minor, please contact us through customer service when you have any questions about the personal information of the minor under your supervision.
            </p>
            <h4>1.Definition</h4>
            <ol class="list decimal-list">
              <li>
                1.Software: refers to the reading tools provided by the software to users, supports the reading of books in the software's built-in bookstore, and provides users with software licenses and services including but not limited to book recommendation, friend sharing and other functions or content. Referred to as "the software" in this agreement.
              </li>
              <li>
                2.User: refers to the user who activates, browses, or uploads data to this software service, and is more referred to as "you" in this agreement.
              </li>
              <li>
                3.Other users: refer to other users of this software who are related to this software service except the user himself.
              </li>
            </ol>
            <h4>2. Scope of the agreement</h4>
            <ol class="list decimal-list">
              <li>
                1.This agreement is an agreement between you and this platform regarding the protection of user personal information and privacy policies when you download, install, and use this software.
              </li>
              <li>
                2.The content of this agreement also includes relevant agreements, statements, business rules and announcement guidelines on the protection of users' personal information and privacy policies that the software may release from time to time (hereinafter collectively referred to as "special rules"). Once the above content is officially released, it is an integral part of this agreement, and you should also abide by it.
              </li>
            </ol>
            <h4>3. User personal information protection and privacy policy</h4>
            <ol class="list decimal-list">
              <li>
                1.Before you use some functions of this service, you need to have a successfully registered account of this software platform, and you need to provide your mobile phone number + verification code ; or other third-party platform account information. For your account information, this platform will use professional encryption storage and transmission methods to ensure information security, and will not collect, use, disclose or disclose without authorization. You are responsible for the safety of your account information. The software does not assume any responsibility for the leakage, tampering, or deletion of related information under this service caused by the leakage of account information due to your own reasons.
              </li>
              <li>
                Regarding the specific rules for your account use, please abide by the relevant account use agreement (including but not limited to the "User Service Agreement of this Software") and other special rules issued by this software for this purpose.
              </li>
              <li>
                2.You understand and agree that in order to provide you with our services, we will ask you to provide the personal information necessary to provide you with the service (we will clearly indicate to you the purpose and method of collecting and using personal information in this privacy policy , Location, storage period and location, and collect information after obtaining your consent). If you do not provide personal information, we may not be able to provide you with our products or services.
                <ul class="textIndet10">
                  <li>
                    2.1 The scope of information collected and used:
                    <ul class="textIndet20">
                      <li>
                        （1）The information you filled in when you registered your account (mobile phone number), and the information you uploaded when you used the service.
                      </li>
                      <li>
                        （2）The information you submit through our customer service or when participating in events held by us, and the information we obtain when you use the service.
                      </li>
                      <li>
                        The detailed list is as follows:
                        <ul style="margin-left:20px;">
                          <li>
                            1) Login: The user is authorized to log in to the third-party platform account , avatar, nickname, or mobile phone number + verification code to log in to the mobile phone number ;
                          </li>
                          <li>
                            2) Edit information: account picture, nickname, gender ;
                          </li>
                          <li>
                            3) Account: Account ID (a unique identifier generated by the system, users cannot edit), account avatar, nickname, gender;
                          </li>
                          <li>
                            4) Sign-in calendar: If you click on the sign-in logo, you will get a certain amount of rewards, which can be claimed once a day and cannot be repeated. The sign-in rules are subject to the page display;
                          </li>
                          <li>
                            5) Notification: If you agree and actively click "Allow", we will send you a push notification. You can set the notification sound and mark in the mobile phone system; if you want to turn off push notifications, you can use the mobile phone system Set to close the notification;
                          </li>
                          <li>
                            6) Today's reading: Count the user's reading time in this software APP that day, the statistical unit is minute;
                          </li>
                          <li>
                            7) Reading history: users read books (books that the user has read in this software using the same device), add books to the bookshelf (all books added to the bookshelf by the user on the same device, the user can delete the added books), manage reading history (in the delete column) books);
                          </li>
                          <li>
                            8) Reading records: browsing records (books browsed by the user using the same device in this software), bookshelf records (all books added to the bookshelf by the user using the same account, the user can delete the books that have been added to the bookshelf record, and the books in the bookshelf record Add the local bookshelf of the device), manage the bookshelf (delete the books in the bookshelf). In order to realize the bookshelf record function, you need to log in to the software to register an account. If you refuse to log in, you cannot use it;
                          </li>
                          <li>
                            9) Bookshelf: When you open this software APP for the first time, we may actively recommend high-quality books to you and add them to your bookshelf. You can also put the books you are reading or like in the bookshelf to find them, or you can delete them. Hope to keep the books in the shelf;
                          </li>
                          <li>
                            10) Import books: If you agree and actively click to import books, we will open the import local books page. If you agree and actively click the smart guide, we will scan your device after obtaining your authorization, and display all the scanned TXT, EPUB, MOBI format files, you can manually check to confirm that you need to add the device Books on the local bookshelf; if you agree and actively click on the mobile phone directory, you can choose TXT, EPUB, MOBI format file paths and add them to the local bookshelf of the device. In order to provide this service, we need to obtain SD card permissions for your device. You agree and confirm that the files you import from the device to the local bookshelf do not contain any content that violates relevant laws and regulations or infringes the legal rights and interests of third parties, and you shall bear full responsibility for this;
                          </li>
                          <li>
                            11) WiFiWiFi transfer: If you agree and actively click on WiFi transfer, we will provide you with a link address, you can enter the link address into the address bar of the computer browser, and drag the TXT format file in the computer to The link page specifies the upload area, and the file can be transferred to the local bookshelf of the phone. If you want to get this service, you need to make sure that your computer and your phone are connected to the same WiFi, and we need to identify your phone's WiFi name ;
                          </li>
                          <li>
                            12) Message notification: notifications in the software system, including nickname modification, avatar modification and other messages related to your account (we need to identify your registered software account), as well as general notifications;
                          </li>
                          <li>
                            13) Full site free of advertisements: Users who pay to open VIP members can enjoy membership rights such as free of advertisements on book reading pages and addition of distinguished logos (this software has the right to update membership rights from time to time, and the details are subject to the updated "Member Service Agreement") , If you agree and actively click "Activate Now", the Apple Store payment page (iOS system) or three-party payment page (Android system) will be opened, but we only get your payment information , and Will not obtain other information including payment account, password, fingerprint;
                          </li>
                          <li>
                            14) Account binding: My-Settings-Account Management page, you can bind your mobile phone number , you can change the bound mobile phone number , if you want to cancel your mobile phone number, please contact Our customer service;
                          </li>
                          <li>
                            15) In order to achieve sharing and push functions, we use MobTech’s ShareSDK product. For the privacy policy of this product, please refer to: https://www.mob.com/about/policy;
                          </li>
                          <li>
                            16) Help and feedback: If you agree and actively click "I want to feedback", you need to submit the problem description, problem picture (optional), and the user's contact information, mobile phone number .
                          </li>
                          <li>
                            The permissions corresponding to the above functions are all required permissions for business functions. If you do not grant the corresponding permissions, you cannot use the related functions.
                          </li>
                          <li>
                            Some of our services may require you to provide specific personal sensitive information to achieve specific functions. If you choose not to provide this type of information, you may not be able to use certain functions in the service normally, but it will not affect your use of other functions in the service. If you take the initiative to provide your sensitive personal information, it means that you agree that we will process your sensitive personal information in accordance with the purposes and methods described in this agreement.
                          </li>
                          <li>
                            Personal sensitive information refers to personal information that, once leaked, illegally provided or misused, may endanger personal and property safety, and easily lead to personal reputation, physical and mental health damage, or discriminatory treatment. Personal sensitive information includes ID number, personal biometric information, bank account number, communication content, health and physiological information, etc. The content of "personal information" or "personal sensitive information" in this privacy policy comes from GB/T35273 "Personal Information Security Regulations", and the definition is consistent with the definitions in "Personal Information Security Regulations".
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    2.2 For users using the Android system, when you use this software, for the purpose of providing, processing, maintaining, improving, developing our products and/or providing services to you, this software may obtain the following permissions for your terminal device:
                    <ul>
                      <li>
                        （1）Allow access to the network;
                      </li>
                      <li>
                        （2）Allow access to WiFi status permissions;
                      </li>
                      <li>
                        （3）Allow access to network status permissions;
                      </li>
                      <li>
                        （4）Allow writing to external storage permissions;
                      </li>
                      <li>
                        （5）Allow to read the unique ID permission of the device;
                      </li>
                      <li>
                        （6）Allow to write system settings permissions;
                      </li>
                      <li>
                        （7）Allow to read external storage permissions;
                      </li>
                      <li>
                        （8）Allow program vibration permission;
                      </li>
                      <li>
                        （9）Allow the system to pop up dialog box permissions;
                      </li>
                      <li>
                        （10）Allow obtaining CellID or WiFi hotspot to obtain your rough location permission, we can obtain it, if you turn off the authorization, we cannot continue to obtain the information;
                      </li>
                      <li>
                        （11）The permission to obtain GPS positioning information is permitted. We can only obtain it if you allow it in the mobile phone system settings. If you turn off the authorization, we cannot continue to obtain the information;
                      </li>
                      <li>
                        （12）Allow to obtain permission to install App;
                      </li>
                      <li>
                        （13）Permission to request access to use photographs and photo albums;
                      </li>
                      <li>
                        （14）Allow the application process to still run after the phone is locked;
                      </li>
                      <li>
                        （15）Allow to read the system bottom log permissions.
                      </li>
                    </ul>
                  </li>
                  <li>
                    2.3 For users who use iOS, when you use this software, for the purpose of providing, processing, maintaining, improving, and developing our products and/or services provided to you, this software may obtain the following permissions for your terminal device:
                    <ul>
                      <li>
                        （1）Allow access to the network;
                      </li>
                      <li>
                        （2）Allow access to WiFi status permissions;
                      </li>
                      <li>
                        （3）Allow access to network status permissions;
                      </li>
                      <li>
                        （4）Allow access to location information;
                      </li>
                      <li>
                        （5）Allow to request permission to access and use photos and photo albums;
                      </li>
                      <li>
                        （6）Allow to obtain message push permission.
                      </li>
                    </ul>
                  </li>
                  <li>
                    2.4 How do we share, transfer and publicly disclose your personal information
                    <ul class="textIndet20">
                      <li>
                        2.4.1 Sharing
                        <ul>
                          <li>
                            We attach great importance to the protection of your personal information. Your personal information is an important basis and part of the products and/or services we provide to you. For your personal information, we will only use this "Privacy Policy" for the purposes and Collect and use within the scope or in accordance with the requirements of laws and regulations, and strictly confidential, we will not share your personal information with third-party companies, organizations and individuals other than the software and its affiliates, unless there are one or more of the following situations :
                          </li>
                          <li>
                            （1）You make a request by yourself.
                          </li>
                          <li>
                            （2）Your explicit authorization has been obtained in advance.
                          </li>
                          <li>
                            （3）Necessary and reasonable sharing within the software and its related parties. You understand and agree that some personal information that does not include your personal sensitive information in the registered account information of this software and related reading data may be shared with our affiliated companies. We will work hard to ensure that affiliated companies take no less than the level of security measures promised in this privacy policy and comply with other security protection requirements we put forward to protect your personal information.
                          </li>
                          <li>
                            （4）Necessary sharing with some business partners:
                          </li>
                          <li>
                            Third-party SDK service providers: Our products may include third-party SDKs or other similar applications. If you use such third-party services on our platform, you agree that they will directly collect and process your Information (e.g. in the form of embedded code, plug-in, etc.), for example: Ad Alliance SDK needs to read your IMEI information. The collection and processing of information by the aforementioned service providers abide by their own privacy clauses and do not apply to this policy. However, we will also work hard to review the business access qualification of the third party and strive to require the legal compliance and safety of these service providers. In order to ensure the security of your information to the greatest extent, we strongly recommend that you review the privacy policy of any third-party SDK services before using them. To protect your legitimate rights and interests, if you find that these SDKs or other similar applications are at risk, it is recommended that you immediately terminate the relevant operations and contact us in time;
                          </li>
                          <li>
                            （5）What is shared is de-identified information, and the third party receiving the information sharing cannot re-identify the identity of the information subject;
                          </li>
                          <li>
                            （6）Sharing with third parties in order to protect you, our other users or employees, the software or the public interest, property or safety (for example: fraud or credit risk, etc.) from damage;
                          </li>
                          <li>
                            （7）In some cases, only by sharing your personal information can we realize the core functions of our products and/or services or provide the services you need, or deal with disputes or disputes between you and others;
                          </li>
                          <li>
                            （8）It is shared based on relevant agreements (such as online agreements, platform rules, etc.) or legal documents signed by you and us;
                          </li>
                          <li>
                            （9）It complies with the relevant agreement between you and other third parties;
                          </li>
                          <li>
                            （10）Sharing based on reasonable business habits, for example: sharing information about the winners/winners in joint marketing activities with third parties so that they can issue prizes/gifts to you in time; we accept due diligence, etc.;
                          </li>
                          <li>
                            （11）The requirements of the competent authority, the needs of litigation and disputes, and other situations that require sharing as required by laws and regulations.
                          </li>
                          <li>
                            We will only share your personal information for legal, legitimate, necessary, specific, and clear purposes, and will only share necessary personal information. When we share information with our business partners, we will strictly require them to fulfill their responsibility to protect your personal information.
                          </li>
                        </ul>
                      </li>
                      <li>
                        2.4.2 Transfer
                        <ul>
                          <li>
                            Transfer refers to the process of transferring control of personal information to other companies, organizations or individuals. In principle, we will not transfer your personal information, except in the following cases:
                          </li>
                          <li>
                            （1）You request by yourself;
                          </li>
                          <li>
                            （2）Your explicit authorization has been obtained in advance;
                          </li>
                          <li>
                            （3）If we carry out mergers, acquisitions, reorganizations, divisions, bankruptcies, asset transfers or similar transactions, and your personal information may be transferred as part of such transactions, we will require the new holders to continue to comply with and Fulfill all the contents of the "Privacy Policy" (including purpose of use, rules of use, security protection measures, etc.), otherwise we will require them to re-obtain your express authorization and consent;
                          </li>
                          <li>
                            （4）Other circumstances stipulated by laws and regulations.
                          </li>
                          <li>
                            If the transfer is really necessary for the above reasons, we will inform you of the purpose and type of the transferred information before the transfer (if your personal sensitive information is involved, we will also inform you of the content of the sensitive information involved), and Re-transfer after obtaining your authorization, unless otherwise stipulated by laws and regulations or otherwise stipulated in this policy.
                          </li>
                        </ul>
                      </li>
                      <li>
                        2.4.3 Public disclosure
                        <ul>
                          <li>
                            Public disclosure is the act of publishing information to the society or unspecified people. We will not disclose your personal information publicly except for necessary disclosures due to the need to make announcements on penalties for illegal accounts, fraudulent behaviors, and desensitize relevant information when the list of winners/winners are announced. If there are reasonable grounds for public disclosure, we will inform you of the purpose and type of publicly disclosed information before public disclosure (if your personal sensitive information is involved, we will also inform you of the content of the sensitive information involved), And publicly disclose it after obtaining your authorization, unless otherwise provided by laws and regulations or otherwise agreed in this policy.
                          </li>
                          <li>
                            Regarding publicly disclosed personal information, we will pay full attention to risks, and carefully review its legitimacy, reasonableness, and legality as soon as we receive a public disclosure application, and take appropriate measures during and after public disclosure. It is protected to the extent of the personal information security protection measures and means agreed in this Privacy Policy.
                          </li>
                          <li>
                            Please be aware that even if you have obtained your authorization, we will only publicly disclose your personal information for legal, legitimate, necessary, specific, and clear purposes, and try to anonymize the personal information in the public disclosure content.
                          </li>
                          <li>
                            According to laws and regulations, under the following circumstances, sharing, transferring, and publicly disclosing your personal information does not require your prior authorization and consent:
                          </li>
                          <li>
                            （1）Directly related to national security and national defense security;
                          </li>
                          <li>
                            （2）It is directly related to public safety, public health, and major public interests;
                          </li>
                          <li>
                            （3）Directly related to criminal investigation, prosecution, trial, and execution of judgments; or in accordance with the requirements of laws and regulations, or the requirements of administrative agencies, public prosecutions, and other competent agencies;
                          </li>
                          <li>
                            （4）In order to protect your or other individuals' life, property and other major legal rights, but it is difficult to obtain your own consent;
                          </li>
                          <li>
                            （5）Personal information is disclosed to the public by you yourself or collected from legally disclosed channels (such as legal news reports, government information disclosure, etc.);
                          </li>
                          <li>
                            （6）Necessary for signing and performing related agreements or other written documents with you;
                          </li>
                          <li>
                            （7）Other circumstances stipulated by laws and regulations.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    2.5 How do we use cookies and similar technologies
                    <ul>
                      <li>
                        Cookies are very important to improve users' network experience. The software uses cookies for the following purposes:
                      </li>
                      <li>
                        （1）Identity verification
                      </li>
                      <li>
                        CookieCookies can notify us when you access our services so that we can verify your account information to ensure your account security. For example, Cookie technology can notify us when you log in to the software. Therefore, when you visit the software's site, we can identify whether you are logged in safely and show you information related to you.
                      </li>
                      <li>
                        （2）Security
                      </li>
                      <li>
                        CookieCookies can help us ensure the security of data and services, and investigate cheating, hacking, and fraud against our products and services. For example, Cookie can store the ticket information of your token , which can be verified by the server whether it is your own normal login in the software, and the encrypted information in the ticket information can prevent multiple types of attacks and prevent cross-site information Steal access to prevent access by impersonation.
                      </li>
                      <li>
                        （3）Functions and services
                      </li>
                      <li>
                        Cookies can help us provide users with better products and services. For example, Cookie can help you fill in the name of your last login account through the stored information when you log in, so as to improve your operating efficiency.
                      </li>
                      <li>
                        （4）Efficiency
                      </li>
                      <li>
                        Cookies can avoid unnecessary server load, improve service efficiency, and save resources. For example, cookies can help us optimize the traffic routed between servers and understand the speed at which different users load our services. Sometimes, we may use cookies to make you load and respond faster when using the software.
                      </li>
                    </ul>
                  </li>
                  <li>
                    2.6 Ways to use and protect information:
                    <ul class="textIndet20">
                      <li>
                        2.6.1 Protecting users' personal information is a basic principle of this platform, and this platform will take reasonable measures to protect users' personal information. Except as provided by laws and regulations or otherwise agreed in this agreement, this platform will not disclose or disclose user personal information to third parties without the user's permission. This platform uses professional encrypted storage and transmission methods for related information to ensure the security of users' personal information.
                      </li>
                      <li>
                        2.6.2 This platform will use various security technologies and procedures to establish a complete management system to protect your personal information, so as to avoid unauthorized access, use or disclosure. For example, https + self-developed encryption method realizes transmission encryption; adopts JWT identity authentication (currently the most popular cross-domain authentication solution); malicious user traffic detection, freezing accounts after suspicious user behavior analysis, preventing account theft and causing losses to users ; High Availability of the database (High Availability, refers to the design to reduce the time when the system cannot provide services) to prevent the loss of user gold coins and other data, and can be backed up and restored; when the client shows the mobile phone number to the user, the middle 4 digits are added with a "*" sign Hide, protect user's mobile phone number, etc.
                      </li>
                      <li>
                        2.6.3 Without your consent, this software will not share, transfer, or publicly disclose your personal information to any company, organization or individual other than this software, except as otherwise provided by laws and regulations or otherwise agreed in this agreement.
                      </li>
                      <li>
                        2.6.4 You understand and agree that this platform has the right to conduct a technical analysis of the entire user database and make commercial use of the analyzed and desensitized user database without disclosing the private information of a single user.
                      </li>
                    </ul>
                  </li>
                  <li>
                    2.7 Currently, this software does not have personal information going abroad. If personal information needs to go abroad due to business development in the future, we will list the types of personal information going abroad in this policy, and mark them prominently.
                  </li>
                  <li>
                    2.8 You understand and agree that certain functions of this software may let a third party know the user's information, for example: when users share relevant content to third-party products/platforms, the third party will know some of your information, including account avatars , Account nickname, sharing content; moreover, the information you share after sharing will be displayed on the product/platform you share. On this product/platform, third parties can view your information according to their respective product/platform settings, including account avatars, account nicknames, and shared content. If you do not want a third party to know your information, please do not use these functions of the software; if you use these functions of the software, you are deemed to agree that the third party knows your information.
                  </li>
                  <li>
                    2.9 You understand and agree that, in order to provide you with better services, this platform can associate the account's data records (such as purchase records, consumption records, bookshelf content) on the platform's official website and other clients under your software account, the same , The platform company can also link your aforementioned data records in the software to the account on the platform’s official website and other clients.
                  </li>
                  <li>
                    2.10 Information storage
                    <ul class="textIndet20">
                      <li>
                        2.10.1 We will ensure that your personal information is adequately protected in accordance with this privacy policy.
                      </li>
                      <li>
                        2.10.2 Generally speaking, we will only retain your personal information for a period of time (not less than 6 months) necessary to achieve the purpose, unless there is a mandatory retention requirement by law. Our criteria for judging the aforementioned deadlines include:
                        <ul>
                          <li>
                            （1）Complete the service purpose related to you, maintain the corresponding service and business records, and respond to your possible queries or complaints;
                          </li>
                          <li>
                            （2）Guarantee the safety and quality of the services we provide you;
                          </li>
                          <li>
                            （3）Do you agree to a longer retention time;
                          </li>
                          <li>
                            （4）Whether there is any other special agreement on the retention period.
                          </li>
                          <li>
                            After your personal information exceeds the retention period, we will delete your personal information or make it anonymized in accordance with the requirements of applicable laws.
                          </li>
                        </ul>
                      </li>
                      <li>
                        2.10.3Information deletion and anonymization
                      </li>
                      <li>
                        If the software decides to stop operating, we will stop collecting your personal information after the relevant services stop operating. We will send you a notice of suspension of operations in the form of an announcement. Your personal information that has been held will be deleted or anonymized.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ol>
            <h4>4. Your rights</h4>
            <ul>
              <li>
                1. Access your personal information
                <ul>
                  <li>
                    You have the right to access your personal information, except for exceptions provided by laws and regulations. If you wish to exercise the right of data access, you can access it yourself in the following ways:
                  </li>
                  <li>
                    （1）Access basic information such as avatar, nickname, gender, etc.: After entering the APP, click "My", and click "Avatar" to query and access information;
                  </li>
                  <li>
                    （2）Access account binding information: After entering the APP, click "Settings", and click "Accounts and Security" to query and access information.
                  </li>
                </ul>
              </li>
              <li>
                2. Correct your personal information
                <ul>
                  <li>
                    When you find that your personal information needs to be corrected, you can modify it by yourself through the page in "1. Access your personal information", or you can contact customer service to assist you in modifying the information.
                  </li>
                </ul>
              </li>
              <li>
                3. Delete your personal information
                <ul>
                  <li>
                    In the following situations, you can request us to delete personal information:
                  </li>
                  <li>
                    （1）If our handling of personal information violates laws and regulations;
                  </li>
                  <li>
                    （2）If we collect and use your personal information without obtaining your consent;
                  </li>
                  <li>
                    （3）If our handling of personal information violates our agreement with you;
                  </li>
                  <li>
                    （4）If you no longer use our products or services, or you cancel your account;
                  </li>
                  <li>
                    （5）If we no longer provide you with products or services.
                  </li>
                </ul>
              </li>
              <li>
                4. Manage your authorization scope
                <ul>
                  <li>
                    If you want to change the scope of authorization, you can modify the scope of authorization through the mobile phone authority settings. If you cancel the authorization required for a specific function in the service, you may not be able to use the function normally, but it will not affect your use of other functions in the service.
                  </li>
                </ul>
              </li>
              <li>
                5. Log out of account
                <ul class="textIndet20">
                  <li>
                    （1）The cancellation of the account must meet the following conditions:
                    <ul style="margin-left: 20px">
                      <li>
                        1)There has been no change of sensitive information such as mobile phone number change in the past month;
                      </li>
                      <li>
                        2)The account is in a normal state, and there are no restrictions such as being disabled.
                      </li>
                    </ul>
                  </li>
                  <li>
                    （2）After logging out, the relevant information will be cleared and cannot be retrieved, and relevant operations cannot be performed:
                    <ul style="margin-left: 20px">
                      <li>
                        1) Unable to log in or use this software account;
                      </li>
                      <li>
                        2) Bookshelf records in the account will be cleared;
                      </li>
                      <li>
                        3) Member rights in the account will be cleared;
                      </li>
                      <li>
                        4) Inviting friends in the account will be cleared;
                      </li>
                      <li>
                        5) The sign-in record in the account will be cleared;
                      </li>
                    </ul>
                  </li>
                  <li>
                    （3）In the following situations, we may not be able to respond to your request in accordance with the requirements of laws and regulations:
                    <ul style="margin-left: 20px">
                      <li>
                        1) Directly related to national security and national defense security;
                      </li>
                      <li>
                        2) It is directly related to public safety, public health, and major public interests;
                      </li>
                      <li>
                        3) Related to the execution of criminal investigation, prosecution, trial and judgment execution;
                      </li>
                      <li>
                        4) There is sufficient evidence to show that you have subjective malice or abuse of rights;
                      </li>
                      <li>
                        5) Responding to your request will cause serious damage to the legitimate rights and interests of you or other individuals or organizations;
                      </li>
                      <li>
                        6) Involving trade secrets.
                      </li>
                    </ul>
                  </li>
                  <li>
                    （4）Logout operation
                    <ul style="margin-left: 20px">
                      <li>
                        Click "Settings", click "Accounts and Security", click "Account Security", click "Cancel Account", click "Agree and cancel account", click "Apply to cancel account after verification". After the account cancellation application is submitted for review, we will complete the review within 5-7 working days. Before the account is officially cancelled, you can terminate the cancellation process through account login.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
            <h4>5.Notice and service</h4>
            <ul>
              <li>
                All notices under this agreement can be delivered through important page announcements, e-mails, short messages or regular mail delivery; such notices are deemed to have been delivered to the recipient on the day of delivery.
              </li>
            </ul>
            <h4>6.Other</h4>
            <ul>
              <li>
                1.Your use of this software means that you have read and agreed to be bound by this agreement. This platform has the right to modify the terms of this agreement when necessary. You can check the relevant agreement terms in the latest version of this software, and this platform will also post it in a prominent place in this software. After the terms of this agreement are changed, if you continue to use the software, you are deemed to have accepted the revised agreement. If you do not accept the revised agreement, you should stop using the software.
              </li>
              <li>
                2.The establishment, entry into force, performance, interpretation and dispute resolution of this agreement shall be governed by the laws of the mainland of the People's Republic of China (excluding conflict of laws).
              </li>
              <li>
                3.If there is any dispute or dispute between you and this platform, you should first settle it through friendly negotiation; if the negotiation fails, you agree to submit the dispute or dispute to the people's court with jurisdiction in the place where this agreement is signed.
              </li>
              <li>
                4.The titles of all terms in this agreement are for reading convenience only, and they have no actual meaning and cannot be used as the basis for interpretation of the meaning of this agreement.
              </li>
              <li>
                5.No matter the terms of this agreement are partially invalid or unenforceable for any reason, the remaining terms are still valid and binding on both parties.
              </li>
              <li>
                6. Email to: hwkefu@gmail.com.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "utils/core/rem";
export default {
  data () {
    return {
      flag: 'zh_TW '
    }
  },
};
</script>

<style lang="stylus" scoped>
.agreeWrap
    font-size 14px
    padding 10px
    line-height 38px
    background #fff
    p
      margin-top 10px
    h4
        padding 20px 0
        font-size 18px
    li
        margin 10px 0
.textIndet10
   text-indent 10px
.textIndet20
  text-indent 20px
</style>
